import { useEffect, useState, type RefObject } from 'react'

export const useElementWidth = <T extends HTMLElement>(
  elementRef: RefObject<T>
): number | undefined => {
  const [width, setWidth] = useState<number | undefined>(undefined)

  useEffect(() => {
    const element = elementRef.current
    if (!element) {
      setWidth(undefined)
      return
    }

    setWidth(element.clientWidth)

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setWidth(entry.target.clientWidth)
      }
    })

    resizeObserver.observe(element)

    return () => {
      resizeObserver.disconnect()
    }
  }, [elementRef])

  return width
}
